import { DynamicHeightScrollArea } from "@/components/atoms/DynamicHeightScrollArea";
import { Button } from "@/components/ui/button";
import { DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertDialogContent } from "@/components/ui/alert-dialog";
import { dialog, DialogRendererProps } from "@/lib/dynamic-dialog-state";
import { Info } from "lucide-react";
import { UseCheckSyncSurveysWithTemplateReturnData } from "../../../hooks/useCheckSyncSurveysWithTemplate";
import { SurveyCheckResultItem } from "../../molecules/SurveyCheckResultItem/SurveyCheckResultItem";
import { SelectedItemsForSync } from "@/features/survey_sync/types/selectedItemsForSync";
import { useState } from "react";
import { SelectedItemsForSyncProvider } from "@/features/survey_sync/context/selectedItemsForSyncContext";
import { BorderBox } from "@/components/atoms/BorderBox";

export interface DangerousSyncDialogProps {
    checkResult: UseCheckSyncSurveysWithTemplateReturnData
}


export function DangerousSyncDialog(props: DangerousSyncDialogProps & DialogRendererProps<SelectedItemsForSync>) {
    // console.log(props.checkResult)
    const [selectedItemsForSync, setSelectedItemsForSync] = useState<SelectedItemsForSync>({});
    return (
        <AlertDialogContent className="max-w-[80vw]">
            <SelectedItemsForSyncProvider value={{ selectedItemsForSync, setSelectedItemsForSync }}>
                <div className="flex flex-col h-[80vh]">
                    <DialogHeader>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full bg-blue-500/10">
                                <Info className="w-5 h-5 text-blue-500" />
                            </div>
                            <div>
                                <DialogTitle className="text-lg font-semibold text-foreground">
                                    Syncing this survey template might lead to undesired data loss
                                </DialogTitle>
                                <DialogDescription className="text-sm text-muted-foreground">
                                    It will update {props.checkResult.length} survey{props.checkResult.length !== 1 ? 's' : ''} that {props.checkResult.length !== 1 ? 'are' : 'is'} linked to this template.
                                    <BorderBox size={"xs"} className="flex items-start" variant={'danger'}>
                                        All questions that will be synchronized will lose their answers.
                                    </BorderBox>
                                </DialogDescription>
                            </div>
                        </div>
                    </DialogHeader>

                    <div className="flex flex-col justify-end flex-1 max-h-[80vh] h-full">
                        <div className="flex flex-col flex-1 ">
                            <DynamicHeightScrollArea offset={130}>
                                <div className="flex flex-col gap-2">
                                    {props.checkResult.map(survey => (<SurveyCheckResultItem key={survey.surveyInstance.id} {...survey} />))}
                                </div>
                            </DynamicHeightScrollArea>
                        </div>
                        <div className="flex justify-end gap-2 pt-2">
                            <Button
                                onClick={props.cancel}
                                variant={"outline"}
                                size='sm'
                            >
                                Cancel
                            </Button>
                            <Button
                                variant={"destructive"}
                                onClick={() => {
                                    props.confirm(selectedItemsForSync)
                                }}
                                size='sm'
                            >
                                Confirm
                            </Button>
                        </div>
                    </div>
                </div>
            </SelectedItemsForSyncProvider>
        </AlertDialogContent>
    );
}

export const dangerousSyncDialog = dialog(DangerousSyncDialog)